<template>
  <div class="flexBetween" style="display: flex;">
    <div class="tabsContainer">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="电表" name="first">电表</el-tab-pane>
        <el-tab-pane label="水表" name="second">水表</el-tab-pane>
      </el-tabs>
      <div class="tabHeader">
        <span v-for="tab in tabList" :key="'tab'+tab.value" :class="{'tabAct':nowTab == tab.value}"
          @click="nowTab = tab.value">{{tab.name}}</span>
      </div>

      <div v-show="nowTab == 0" class="custom-scrollbar tabBody" style="height: calc(100% - 32px);">
        <div class="chargingDetailLi" v-for="single in allChargeMode.SingleBilling" :key="'single'+single.id">
          <p class="chargingTitle">计费名称： {{single.name}}</p>
          <p class="chargingPrice">单价:{{single.deductionStandard}}元/度</p>
          <!-- <div class="line"></div> -->
          <div class="chargingOperate">
            <span @click="editChargeMode(single)">编辑</span>
            <el-popconfirm title="确定要删除此单价计费吗？" @onConfirm="deleteChargeMode(single)">
              <span slot="reference">删除</span>
            </el-popconfirm>
            <!-- <span @click="deleteChargeMode(single)">删除</span> -->
          </div>
        </div>
        <div class="addNewCharging" style="height: 145px;">
          <img @click="addSingleCharge"
            :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
        </div>
      </div>
      <div v-show="nowTab == 3" class="custom-scrollbar tabBody" style="height: calc(100% - 32px);">
        <div class="chargingDetailLi" v-for="single in allChargeMode.SingleBilling" :key="'single'+single.id">
          <p class="chargingTitle">计费名称： {{single.name}}</p>
          <p class="chargingPrice">单价:{{single.deductionStandard}}元/m³</p>
          <div class="chargingOperate">
            <span @click="editChargeMode(single)">编辑</span>
            <el-popconfirm title="确定要删除此单价计费吗？" @onConfirm="deleteChargeMode(single)">
              <span slot="reference">删除</span>
            </el-popconfirm>
            <!-- <span @click="deleteChargeMode(single)">删除</span> -->
          </div>
        </div>
        <div class="addNewCharging" style="height: 118px;">
          <img @click="addSingleCharge"
            :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
        </div>
      </div>

      <div v-show="nowTab == 1" class="custom-scrollbar tabBody" style="height: calc(100% - 32px);">
        <div class="chargingDetailLi chargingDetailLi2" v-for="step in allChargeMode.StepBilling" :key="'step'+step.id">
          <p class="chargingTitle">计费名称： {{step.name}}</p>
          <div class="chargingDetails">
            <p class="flexBetween">第一阶梯： 0-{{step.stairNumOne}}度<span>{{step.priceOne}}元/度</span></p>
            <p class="flexBetween">第二阶梯： {{step.stairNumOne}}-{{step.stairNumTwo}}度<span>{{step.priceTwo}}元/度</span></p>
            <p class="flexBetween">第三阶梯： {{step.stairNumTwo}}度以上<span>{{step.priceThree}}元/度</span></p>
          </div>
          <div class="chargingOperate">
            <span @click="editChargeMode(step)">编辑</span>
            <el-popconfirm title="确定要删除此阶梯计费吗？" @onConfirm="deleteChargeMode(step)">
              <span slot="reference">删除</span>
            </el-popconfirm>
            <!-- <span @click="deleteChargeMode(step)">删除</span> -->
          </div>
        </div>
        <div class="addNewCharging" style="height: 208px;">
          <img @click="addStepCharge"
            :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
        </div>
      </div>

      <div v-show="nowTab == 4" class="custom-scrollbar tabBody" style="height: calc(100% - 32px);">
        <div class="chargingDetailLi" v-for="step in allChargeMode.StepBilling" :key="'step'+step.id">
          <p class="chargingTitle">计费名称： {{step.name}}</p>
          <div class="chargingDetails">
            <p class="flexBetween">第一阶梯： 0-{{step.stairNumOne}}m³<span>{{step.priceOne}}元/m³</span></p>
            <p class="flexBetween">第二阶梯： {{step.stairNumOne}}-{{step.stairNumTwo}}m³<span>{{step.priceTwo}}元/m³</span>
            </p>
            <p class="flexBetween">第三阶梯： {{step.stairNumTwo}}m³以上<span>{{step.priceThree}}元/m³</span></p>
          </div>
          <div class="chargingOperate">
            <span @click="editChargeMode(step)">编辑</span>
            <el-popconfirm title="确定要删除此阶梯计费吗？" @onConfirm="deleteChargeMode(step)">
              <span slot="reference">删除</span>
            </el-popconfirm>
            <!-- <span @click="deleteChargeMode(step)">删除</span> -->
          </div>
        </div>
        <div class="addNewCharging" style="height: 171px;">
          <img @click="addStepCharge"
            :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
        </div>
      </div>

      <!--尖峰平谷-->
      <div v-show="nowTab == 2" class="custom-scrollbar tabBody" style="height:900px;width: 2500px">
        <div class="chargingDetailLi chargingDetailLi3" v-for="item in allChargeMode.PeakAndValleyBilling"
          :key="'peakAndVallyey'+item.id">
          <p class="chargingTitle">计费名称： {{item.name}}</p>
          <!--tabs标签-->
          <!-- <el-tabs type="border-card">
						<el-tab-pane  v-for = "(d,index)  in item.detail" >
							<span slot="label"><i class="el-icon-date"></i> {{d.tname}}</span>
							{{d.rateMoney}}元/度
						</el-tab-pane>
					</el-tabs> -->
          <div class="chargingDetails">
            <p class="flexBetween" v-for="(t,index) in item.detail" :key="index">
              <span>{{t.tname}}</span>
              <span>{{t.rateMoney}}元/度</span>
            </p>
            <!-- <p class="flexBetween">{{step.stairNumOne}}-{{step.stairNumTwo}}m³<span>{{step.priceTwo}}元/m³</span></p>
						<p class="flexBetween">{{step.stairNumTwo}}m³以上<span>{{step.priceThree}}元/m³</span></p> -->
          </div>

          <div class="chargingOperate">
            <span @click="editSPeakAndValleyBillingCharge(item)">编辑</span>
            <el-popconfirm title="确定要删除此费率计费吗？" @onConfirm="deleteChargeMode(item)">
              <span slot="reference">删除</span>
            </el-popconfirm>
            <!-- <span @click="deleteChargeMode(item)">删除</span> -->
          </div>

        </div>

        <div class="addNewCharging" style="height: 240px;">
          <!-- addSPeakAndValleyBillingCharge -->
          <!-- <img @click="addSingleCharge" :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" /> -->
          <img @click="addSPeakAndValleyBillingCharge"
            :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/add_btn.png')" alt="" />
          <!-- addSingleCharge -->
        </div>

      </div>
    </div>

    <AddNewChargingDialog ref="addNewCharging"></AddNewChargingDialog>
    <PeakAndValleyBillingViewDialog ref="peakAndValleyBillingViewDialog"></PeakAndValleyBillingViewDialog>
  </div>
</template>

<script>
  import AddNewChargingDialog from './dialogs/AddNewChargingDialog.vue'
  import PeakAndValleyBillingViewDialog from './dialogs/PeakAndValleyBillingViewDialog.vue'
  import meterManagerStore from './meterManagerStore.js'
  export default {
    components: {
      AddNewChargingDialog,
      PeakAndValleyBillingViewDialog
    },
    props: {},
    data () {
      return {
        nowTab: 0,
        tabList: [{name: '单价计费',value: 0},{name: '阶梯计费',value: 1},{name: '费率计费',value: 2}],
        activeName: 'first',

        nowUnitInfo: {}
      }
    },
    created () {},
    mounted () {
      meterManagerStore.commit("setNowUser",this.nowUser)
      meterManagerStore.commit("setNowUnit",{
        unit: this.nowUnit,activeName: this.activeName
      })
    },
    destroyed () {},
    computed: {
      nowUser () {
        return this.$store.userStore.state.nowUserInfo
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      allChargeMode () {
        return {
          "StepBilling": [
            {
              "createTime": 1713341840000,
              "pkid": 328753078323201,
              "name": "112",
              "billingMode": "StepBilling",
              "deductionStandard": "1:1;5:22;33",
              "unitId": "63c8d075643f4a04bda34d97d8fce42a",
              "activeName": "first",
              "state": 0,
              "id": "328753078323201",
              "entityName": "MeterBillingMode",
              "priceOne": "1",
              "priceTwo": "22",
              "priceThree": "33",
              "stairNumOne": "1",
              "stairNumTwo": "5"
            }
          ],
          "SingleBilling": [
            {
              "createTime": 1713341810000,
              "pkid": 328753017323521,
              "name": "23",
              "billingMode": "SingleBilling",
              "deductionStandard": "023",
              "unitId": "63c8d075643f4a04bda34d97d8fce42a",
              "activeName": "first",
              "state": 0,
              "id": "328753017323521",
              "entityName": "MeterBillingMode"
            }
          ],
          "PeakAndValleyBilling": [
            {
              "pkid": 328753101651969,
              "name": "23",
              "unitId": "63c8d075643f4a04bda34d97d8fce42a",
              "id": 328753101651969,
              "detail": [
                {
                  "id": "41f8f6c5c4264c539ace2a95ed985fd5",
                  "create_time": 1713341851000,
                  "billingModeId": "328753101651969",
                  "name": "23",
                  "rateMoney": 23,
                  "type": 1,
                  "tname": "尖"
                },
                {
                  "id": "3724559b05bc48d0bbaf10d998deecb3",
                  "create_time": 1713341851000,
                  "billingModeId": "328753101651969",
                  "name": "23",
                  "rateMoney": 3,
                  "type": 2,
                  "tname": "峰"
                },
                {
                  "id": "d08c15948e4d45829099d74d35e839cc",
                  "create_time": 1713341851000,
                  "billingModeId": "328753101651969",
                  "name": "23",
                  "rateMoney": 4,
                  "type": 3,
                  "tname": "平"
                },
                {
                  "id": "fe6c52e2d949421f86d488090dc3c472",
                  "create_time": 1713341851000,
                  "billingModeId": "328753101651969",
                  "name": "23",
                  "rateMoney": 5,
                  "type": 4,
                  "tname": "谷"
                }
              ]
            }
          ]
        }
      },
    },
    watch: {
      nowUser (nv,ov) {
        meterManagerStore.commit("setNowUser",nv)
      }
    },
    methods: {
      handleClick (tab,event) {

        if(this.activeName=='second') {

          this.nowTab=3;
          this.tabList=[{name: '单价计费',value: 3},{name: '阶梯计费',value: 4}];

        } else {
          this.nowTab=0;
          this.tabList=[{name: '单价计费',value: 0},{name: '阶梯计费',value: 1},{name: '费率计费',value: 2}];
        }

        meterManagerStore.commit("setNowUnit",{
          unit: this.nowUnit,activeName: this.activeName
        })
      },
      saveUnitInfo () {

      },
      addSingleCharge () {
        this.$refs.addNewCharging.open('新增单价计费','single',this.activeName,{},result => {
          this.saveChargeMode(result)
        })
      },
      addStepCharge () {
        this.$refs.addNewCharging.open('新增阶梯计费','step',this.activeName,{},result => {
          this.saveChargeMode(result)
        })
      },

      //lxk 2020-09-14新增尖峰平谷
      addSPeakAndValleyBillingCharge () {
        this.$refs.peakAndValleyBillingViewDialog.open('新增费率计费','',{},result => {
          console.log("尖峰平谷",result);
          this.saveChargeMode(result)
        })
      },

      //lxk 2020-09-14编辑尖峰平谷
      editSPeakAndValleyBillingCharge (item) {
        this.$refs.peakAndValleyBillingViewDialog.open('编辑费率计费','',item,result => {
          this.saveChargeMode(result)
        })
      },

      // 保存计费方式
      saveChargeMode (data) {
        this.$api.meterReadingApi.saveMeterBillingMode(data.pkid,data.name,this.activeName,data.billingMode,data.deductionStandard,this.nowUnit.id,respon => {
          this.$dialogMethod.showMessage('保存成功')
          meterManagerStore.commit('getAllMeterBillingMode',{
            unitId: this.nowUnit.id,activeName: this.activeName
          })
        },err => {
          this.$dialogMethod.showMessage('保存失败')
        })
      },

      // 删除计费方式
      deleteChargeMode (item) {
        this.$api.meterReadingApi.deleteMeterBillingMode(item.pkid,respon => {
          this.$dialogMethod.showMessage(respon)
          meterManagerStore.commit('getAllMeterBillingMode',{
            unitId: this.nowUnit.id,activeName: this.activeName
          })
        },err => {
          this.$dialogMethod.showMessage(err)
        })
      },
      // 编辑计费方式
      editChargeMode (item) {
        if(item.billingMode=='SingleBilling') {
          this.$refs.addNewCharging.open('编辑单价计费','single',this.activeName,item,result => {
            this.saveChargeMode(result)
          })
        } else if(item.billingMode=='StepBilling') {
          this.$refs.addNewCharging.open('编辑阶梯计费','step',this.activeName,item,result => {
            this.saveChargeMode(result)
          })
        }
      },
      // 查看费率计费详情
      viewDetails (item) {
        this.$refs.peakAndValleyBillingViewDialog.open(copy(item))
      }
    }
  }
</script>

<style scoped>
  .tabsContainer {
    width: calc(100% - 40px);
    padding: 20px;
    height: calc(100% - 40px);
    background: #FFFFFF;
  }

  .chargingDetailLi {
    width: calc((100% - 176px) / 6.5);
    /* border-bottom: solid 1px #E4E4E4; */
    border-radius: 6px;
    margin: 30px 10px 0 10px;
    /* text-align: center; */
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 4px 8px 0px #e8eff5;

  }

  .chargingDetailLi2 {
    width: calc((100% - 176px) / 5);
  }

  .chargingDetailLi3 {
    width: calc((100% - 176px) / 10);
  }

  .chargingTitle {
    line-height: 45px;
    /* background-color: #F2F2F2; */
    background-color: #DBEDFF;
    /* margin-left: 12px; */
    padding-left: 12px;
    color: #3E9AF8;
    margin-bottom: 10px;


    /* border-bottom: solid 1px #E4E4E4; */
    /* border-bottom: solid 1px #DBEDFF; */
  }

  .chargingPrice {
    line-height: 45px;
    padding-left: 12px;
    color: #1A1A1A;

  }

  .line {
    /* width: calc(100% -0.24rem); */

    width: calc(100% - 0.24rem);
    height: .01rem;
    background-color: #E4E4E4;
    margin-left: .12rem;
  }

  .chargingDetails {
    padding: 0 10px;
  }

  .chargingDetails>p {
    line-height: 0.36rem;
    text-align: left;
    /* color: #919191; */
    color: #1A1A1A;
    /* border-bottom: solid 1px #E4E4E4; */
  }

  .chargingDetails>p:last-child {
    border-bottom: none;
  }

  .chargingDetails>p>span {
    color: #919191;
    color: #1A1A1A;
  }

  .chargingOperate {

    text-align: right;
  }

  .chargingOperate>span {
    display: inline-block;
    line-height: 45px;
    cursor: pointer;
    /* width: calc(50% - 0.5px); */
  }

  .chargingOperate>span:first-child {
    /* border-right: solid 1px #E4E4E4; */
    color: #3E9AF8;
    /* margin-right: 12px; */
  }

  .chargingOperate>span:last-child {
    color: #FF7765;
    margin: 0 12px;
  }

  .addNewCharging {
    display: flex;
    width: calc((100% - 176px) / 8);
    margin: 30px 10px 0 10px;
    align-items: center;
    justify-content: center;
  }

  .addNewCharging>img {

    cursor: pointer;
  }

  .tabHeader {
    border-bottom: solid 1px #E4E4E4;
  }

  .tabHeader>span {
    display: inline-block;
    margin-right: 30px;
    line-height: 30px;
    position: relative;
    top: 1px;
    cursor: pointer;
  }

  .tabAct {
    color: #409EFF;
    border-bottom: solid 1px #409EFF;
  }

  .tabBody {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 1600px) {
    .chargingDetailLi {
      width: calc((100% - 154px) / 7);
    }

    .addNewCharging {
      width: calc((100% - 154px) / 7);
    }
  }

  @media screen and (max-width: 1650px) {
    .chargingDetailLi {
      width: calc((100% - 132px) / 6);
    }

    .addNewCharging {
      width: calc((100% - 132px) / 6);
    }
  }
</style>